document.body.addEventListener("click", (event) => {
  // Check if the clicked element is inside a category button (plp-category-button)
  const categoryButton = event.target.closest(".plp-category-button");

  if (categoryButton) {
    const categoryText = categoryButton.querySelector(
      ".plp-category-button-text"
    ); // Get the text inside the clicked category
    const textContent = categoryText.innerText.trim(); // Get the label text of the clicked category

    // Check if the clicked category already has the 'active-category' class
    if (!categoryButton.classList.contains("active-category")) {
      // Remove 'active-category' from all .plp-category-button elements
      const allCategories = document.querySelectorAll(".plp-category-button");
      allCategories.forEach((button) => {
        button.classList.remove("active-category");
      });

      // Add 'active-category' to the clicked category button
      categoryButton.classList.add("active-category");
    }

    // Uncheck all checkboxes
    uncheckAllCheckboxes();

    // Now click the checkbox based on the label (In stock, Out of stock, etc.)
    clickCheckboxByLabel(textContent);
    event.stopImmediatePropagation();
  }
});

// Function to uncheck all checkboxes
function uncheckAllCheckboxes() {
  const checkboxes = document.querySelectorAll(
    '.facet-checkbox input[type="checkbox"]'
  );
  checkboxes.forEach((checkbox) => {
    checkbox.checked = false; // Uncheck the checkbox
    checkbox.dispatchEvent(new Event("change")); // Trigger change event if needed
  });
}

// Function to find and click the checkbox based on the label value
function clickCheckboxByLabel(labelText) {
  const labels = document.querySelectorAll(".facet-checkbox");
  labels.forEach((label) => {
    const text = label.querySelector("span.plp-filter-label, span");
    let buttonText = text.innerText;
    let resultTextButton = buttonText.replace(/[0-9\[\]()]/g, ""); // Clean the label text

    if (resultTextButton.trim().toUpperCase() == labelText.trim()) {
      const checkbox = label.querySelector('input[type="checkbox"]');
      if (checkbox) {
        // Dispatch a mouse event to simulate a click
        const mouseEvent = new MouseEvent("click", {
          bubbles: true,
          cancelable: true,
          composed: true,
        });
        checkbox.dispatchEvent(mouseEvent);
        checkbox.dispatchEvent(new Event("change"));
      }
    }
  });
}

document.addEventListener("DOMContentLoaded", () => {
  setInitialActiveCategoryFromURL();
});

function setInitialActiveCategoryFromURL() {
  const urlParams = new URLSearchParams(window.location.search);
  const subcategory = urlParams.get("filter.p.m.custom.subcategory_filter");

  if (!subcategory) return;

  const allCategoryButtons = document.querySelectorAll(".plp-category-button");

  allCategoryButtons.forEach((button) => {
    // Remove active class from all
    button.classList.remove("active-category");
  });

  allCategoryButtons.forEach((button) => {
    const categoryTextElement = button.querySelector(
      ".plp-category-button-text"
    );
    if (categoryTextElement) {
      const buttonText = categoryTextElement.innerText
        .replace(/[0-9\[\]()]/g, "")
        .trim()
        .toLowerCase();

      if (buttonText === subcategory.toLowerCase()) {
        // Add active class to matching button
        button.classList.add("active-category");

        // Uncheck all checkboxes
        uncheckAllCheckboxes();

        // Click corresponding checkbox
        clickCheckboxByLabel(categoryTextElement.innerText.trim());
      }
    }
  });
}
